import * as React from "react";
import { Search } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

import HomeSearchForm from "./HomeSearchForm.react";

interface Props {
  locations: { location: string }[];
}

function HomeSearchPanel({ locations }: Props) {
  const [query, setQuery] = React.useState("");
  const [location, setLocation] = React.useState("");

  const submit = (event: React.FormEvent) => {
    event.preventDefault();
    const params = new URLSearchParams();
    if (query.trim()) params.set("q", query.trim());
    if (location) params.set("location", location);
    params.set("page", "1");
    window.location.href = `/jobs?${params.toString()}`;
  };

  return (
      <HomeSearchForm>
        <form onSubmit={submit} className="home-job-search" aria-label="Search jobs">
          <label className="sr-only" htmlFor="home-job-keywords">Keyword or job title</label>
          <div className="relative">
            <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" aria-hidden="true" />
            <Input id="home-job-keywords" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Keyword or job title" className="h-10 rounded-sm bg-background py-2 pl-9 pr-3 focus-visible:ring-2" />
          </div>
          <label className="sr-only" htmlFor="home-job-location">Location</label>
          <Select value={location || "__all_locations__"} onValueChange={(value) => setLocation(value === "__all_locations__" ? "" : value)}>
            <SelectTrigger id="home-job-location" className="h-10 rounded-sm bg-background focus:ring-2"><SelectValue placeholder="All locations" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="__all_locations__">All locations</SelectItem>
              {locations.map((item) => <SelectItem key={item.location} value={item.location}>{item.location}</SelectItem>)}
            </SelectContent>
          </Select>
          <Button type="submit" className="h-10 rounded-sm">Search jobs</Button>
        </form>
      </HomeSearchForm>
  );
}

export default HomeSearchPanel;
